import {
  Datagrid,
  EditButton,
  LongTextField,
  StateField,
  useFieldLabel,
} from "ra-friendsofbabba";
import {
  DateField,
  List as RaList,
  TextField,
  useListContext,
} from "react-admin";
import { ExportMenuButton, PrintButton } from "../component/button";
import React, { useMemo } from "react";
import { green, red } from "@material-ui/core/colors";

import Actions from "../component/list/Actions";
import AdmissibilityStatusInput from "./inputs/AdmissibilityStatusInput";
import CodeField from "./fields/CodeField";
import Empty from "../component/list/Empty";
import ExpandedRow from "./ExpandedRow";
import Filters from "./Filters";
import { UserField } from "../component/field";
import useView from "./useView";

const BACKGROUND_COLORS = {
  sent: green[50],
  sent_late: red[50],
  canceled: red[50],
  admissible: green[50],
  not_admissible: red[50],
};

const List = (props) => {
  const fieldLabel = useFieldLabel({ ...props });
  const isView = useView();
  const { filterValues } = useListContext();
  const { permissions } = props;

  const { isAdmin, isReader, state } = useMemo(
    () => ({
      isAdmin: permissions && permissions(["admin"]),
      isReader: permissions && permissions(["reader"]),
      state: filterValues?.state,
    }),
    [permissions, filterValues?.state]
  );

  return (
    <RaList
      {...props}
      empty={<Empty canCreate />}
      actions={
        <Actions canExport={false}>
          <ExportMenuButton choices={["xlsx"]} />
        </Actions>
      }
      bulkActionButtons={false}
      filters={<Filters />}
      filterDefaultValues={{ state: "admissible" }}
    >
      <Datagrid
        rowClick="edit"
        expand={isAdmin || isView || isReader ? <ExpandedRow /> : null}
        rowStyle={(record) =>
          !isView
            ? {
                backgroundColor: BACKGROUND_COLORS[record?.transaction?.state],
              }
            : undefined
        }
      >
        {(isAdmin || isView) && (
          <TextField
            source="progressive_number"
            label="#ID"
            sortBy="ResearchProjects.progressive_number"
          />
        )}
        <CodeField source="code" />
        {isView && state === "sent" ? (
          <AdmissibilityStatusInput
            source="admissibility_status"
            sortable={false}
          />
        ) : (
          state !== "duplicated" && (
            <StateField source="state" sortable={false} />
          )
        )}
        {(isAdmin || isReader) && (
          <UserField
            label={fieldLabel("user_id")}
            source="user.name"
            sortBy="UserProfiles.surname"
          />
        )}
        <LongTextField
          source="title"
          sortBy="ResearchProjects.title"
          maxRows={3}
        />
        {!isAdmin && !isView && (
          <DateField
            source="modified"
            sortBy="ResearchProjects.modified"
            showTime
          />
        )}
        <DateField
          source="sent.created"
          sortBy="SentTransactions.created"
          showTime
        />
        {!isView && <PrintButton resource="research-projects" />}
        {!isAdmin && !isView && <EditButton />}
      </Datagrid>
    </RaList>
  );
};

export default List;
